export default function ErrorPage({ error }: { error: string }) {
	const style = {
		color: 'grey',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '80vh',
	}

	return (
		<div id="error-page" style={style}>
			<div>
				<h1>Oisann!</h1>
				<p>En uventet feil har skjedd.</p>
				<p>{error}</p>
			</div>
		</div>
	)
}
